import { Base64 } from 'js-base64'
// import { date } from './date'
import { validate } from './validate'
import widget from './widget'

// const lazyload = (name) => (resolve) => require([`@/views/${name}`], resolve)
const lazyload = (name) => () => import(`@/views/${name}`)

const logger = {
  log (message) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(message)
    }
  }
}

const cache = {
  /**
     * userInfo: 用户信息
     */
  setItem (key, value) {
    let data = JSON.stringify(value)
    if (process.env.NODE_ENV === 'production') {
      data = Base64.encode(data)
    }
    sessionStorage.setItem(key, data)
  },
  getItem (key) {
    let data = sessionStorage.getItem(key)
    if (!data) return null
    if (process.env.NODE_ENV === 'production') {
      data = Base64.decode(data)
    }
    return data ? JSON.parse(data) : null
  },
  removeItem (key) {
    sessionStorage.removeItem(key)
  }
}

const cookieUtils = {
  set: function (name, value, days) {
    var d = new Date()
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
    window.document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
  },
  get: function (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  },
  delete: function (name) {
    this.set(name, '', -1)
  }
}

const getQueryString = (name) => {
  let url = window.location.href
  let index = url.indexOf('?')
  let search = url.substr(index + 1)
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = search.match(reg)
  if (r != null) return unescape(r[2])
  return null
}

const util = {
  // 深拷贝
  deepCopy (source, target) {
    target = target || {}
    for (var i in source) {
      if (typeof source[i] === 'object') {
        target[i] = (source[i].constructor === Array) ? [] : {}
        util.deepCopy(source[i], target[i])
      } else {
        target[i] = source[i]
      }
    }
    return target
  },
  ArrayReduce(arr,code){
    var result = [];
    var obj = {};
    for(var i =0; i<arr.length; i++){
       if(!obj[arr[i][code]]){
              result.push(arr[i]);
             obj[arr[i][code]] = true;
           }
    }
    return result
  },
  // 生成uuid
  guid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
  },

  // nodata
  switchNodata (list) {
    return !list || list.length === 0
  },

  // 改变站点title
  changeTitle (title) {
    document.title = title
    // document.body.scrollTop = 0
  },

  /**
     * 随机生成belong
     */
  getBelong () {
    let CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    let chars = CHARS
    let uuid = []
    let i
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        let r = 0 | (Math.random() * 16)
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
      }
    }
    return uuid.join('')
  },
  /**
     * 判断是否两个window 是同一个域中
     */
  InOneDomain(window1, window2) {
    if (window1 == null || window2 == null) {
      return false
    }
    try {
      return window1.location.origin === window2.location.origin
    } catch (e) {
      return false
    }
  },

  /**
     * 获取顶部页面的 url（域）
     */
  GetTopDomain() {
    var url = ''
    // 同一个域
    if (this.InOneDomain(window, window.top)) {
      url = window.top.location.origin
    } else {
      // 跨域
      var tempWindow = window
      while (this.InOneDomain(tempWindow, tempWindow.parent)) {
        tempWindow = tempWindow.parent
      }
      url = tempWindow.document.referrer
      var reg = /http[s]{0,1}:\/\/([^\\/]+)\//i
      var domain = url.match(reg)
      url = domain[0]
    }
    return url
  },
  GetTopUrl() {
    var url = ''
    // 同一个域
    if (this.InOneDomain(window, window.top)) {
      url = window.top.location.href
    } else {
      // 跨域
      var tempWindow = window
      while (this.InOneDomain(tempWindow, tempWindow.parent)) {
        tempWindow = tempWindow.parent
      }
      url = tempWindow.document.referrer
    }
    return url
  }
}

export {
  lazyload,
  logger,
  cache,
  cookieUtils,
  getQueryString,
//   date,
  validate,
  util,
  widget
}
